// extracted by mini-css-extract-plugin
export default {"wrap":"Dp-z","logoContainer":"Ep-z","brandImg":"Fp-z","logoImg":"Gp-z","logoButton":"Hp-z"};